import { Stack } from "@mui/material";

import { ExportModality } from "../../constants";
import { ExportFormMetadata } from "./components/ExportFormMetadata";
import { ExportFormOutputProcessors } from "./components/ExportFormOutputProcessors";
import { ExportFormSaveSelections } from "./components/ExportFormSaveSelections";

interface ExportFormOptionsProps {
  exportModality: ExportModality;
}

export const ExportFormOptions = (props: ExportFormOptionsProps) => {
  const { exportModality } = props;

  return (
    <Stack sx={{ flex: "1 1 0", minWidth: 0, justifyContent: "space-between" }}>
      <Stack spacing={3}>
        {exportModality === "image" && <ExportFormOutputProcessors />}
        <ExportFormMetadata />
      </Stack>
      <ExportFormSaveSelections />
    </Stack>
  );
};
